import React, { useEffect, useState } from 'react';
import logo from '../../photos/logo.png';

function Preloader() {
  const [progress, setProgress] = useState(0);
  const [hiding, setHiding] = useState(false);
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setProgress(prev => {
        if (prev >= 100) {
          clearInterval(interval);
          return 100;
        }
        const increment = Math.random() * 15 + 5;
        return Math.min(prev + increment, 100);
      });
    }, 200);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (progress >= 100) {
      setTimeout(() => setHiding(true), 400);
      setTimeout(() => setHidden(true), 1200);
    }
  }, [progress]);

  if (hidden) return null;

  return (
    <div style={{
      position: 'fixed',
      inset: 0,
      zIndex: 99999,
      background: '#0a0a0f',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      opacity: hiding ? 0 : 1,
      transition: 'opacity 0.8s cubic-bezier(0.4, 0, 0.2, 1)',
      pointerEvents: hiding ? 'none' : 'auto',
    }}>
      {/* Animated rings */}
      <div style={{ position: 'relative', width: 'clamp(140px, 50vw, 200px)', height: 'clamp(140px, 50vw, 200px)', marginBottom: 40, aspectRatio: '1' }}>
        {/* Outer ring */}
        <div style={{
          position: 'absolute',
          inset: 0,
          borderRadius: '50%',
          border: '2px solid rgba(22,183,36,0.1)',
        }} />
        <div style={{
          position: 'absolute',
          inset: 0,
          borderRadius: '50%',
          border: '2px solid transparent',
          borderTopColor: '#16b724',
          animation: 'preloaderSpin 1.5s linear infinite',
        }} />
        {/* Inner ring */}
        <div style={{
          position: 'absolute',
          inset: 30,
          borderRadius: '50%',
          border: '2px solid rgba(22,183,36,0.05)',
        }} />
        <div style={{
          position: 'absolute',
          inset: 30,
          borderRadius: '50%',
          border: '2px solid transparent',
          borderBottomColor: '#4dc247',
          animation: 'preloaderSpin 2s linear infinite reverse',
        }} />
        {/* Logo */}
        <div style={{
          position: 'absolute',
          inset: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}>
          <img src={logo} alt="Logo" style={{
            width: 100,
            filter: 'drop-shadow(0 0 20px rgba(22,183,36,0.3))',
            animation: 'preloaderPulse 2s ease-in-out infinite',
          }} />
        </div>
      </div>

      {/* Progress bar */}
      <div style={{
        width: 'clamp(140px, 50vw, 200px)',
        height: 2,
        background: 'rgba(255,255,255,0.06)',
        borderRadius: 1,
        overflow: 'hidden',
        marginBottom: 16,
      }}>
        <div style={{
          width: `${progress}%`,
          height: '100%',
          background: 'linear-gradient(90deg, #16b724, #4dc247)',
          borderRadius: 1,
          transition: 'width 0.3s ease',
          boxShadow: '0 0 10px rgba(22,183,36,0.5)',
        }} />
      </div>

      {/* Percentage */}
      <div style={{
        color: 'rgba(255,255,255,0.3)',
        fontSize: 'clamp(10px, 2.5vw, 12px)',
        fontFamily: "'Inter', sans-serif",
        letterSpacing: '0.1em',
        fontWeight: 500,
      }}>
        {Math.round(progress)}%
      </div>

      <style>{`
        @keyframes preloaderSpin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
        @keyframes preloaderPulse {
          0%, 100% { transform: scale(1); opacity: 0.8; }
          50% { transform: scale(1.05); opacity: 1; }
        }
      `}</style>
    </div>
  );
}

export default Preloader;
